import apiService from './config';

export function getFeaturesAllowedCompany(feature: string) {
  return apiService.get<void>(`company/feature/${feature}/check`);
}
